export const defaultProvider = 'NxtPort'



// WEBPACK FOOTER //
// ./src/constants/index.ts